//Movies view all page
import React, { useState, useEffect } from "react";
import axiosInstance from "../utils/axios";
import { toast, ToastContainer } from "react-toastify";
import { debounce } from "lodash";
import MovieCard from "../components/MovieCard";
import "react-toastify/dist/ReactToastify.css";
import Title from "../components/common/Title";
import '../styles/Movies.scss';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Movies = () => {
  const [movies, setMovies] = useState({ results: [] });
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState(""); // filter
  const [totalPages, setTotalPages] = useState(1);

  // Debounced fetch
  useEffect(() => {
    const delayFetch = debounce(() => {
      fetchData();
    }, 500);

    delayFetch();
    return () => delayFetch.cancel();
    // eslint-disable-next-line
  }, [search, page, status]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `movie/movie/?page=${page}&search=${search}&status=${status}`
      );
      setMovies(response.data);
      setTotalPages(response.data.total_pages);
    } catch (error) {
      toast.error("Failed to fetch movies");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
    setPage(1);
  };

  const goToPage = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setPage(pageNum);
    }
  };

  return (
    <div className="container my-4">
      {/* Header */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
        <Title text="🎬 Movies" />
        <div className="d-flex gap-2">
          <input
            type="text"
            name="search"
            placeholder="🔍 Search movies..."
            className="form-control"
            value={search}
            onChange={handleSearch}
            style={{ minWidth: "220px" }}
          />
          <select
            className="form-select"
            value={status}
            onChange={handleStatusChange}
          >
            <option value="">All</option>
            <option value="now_showing">Now Showing</option>
            <option value="coming_soon">Coming Soon</option>
          </select>
        </div>
      </div>

      {/* Movie Grid */}
      <div className="row g-4">
        {loading ? (
          <p className="text-center">⏳ Loading movies...</p>
        ) : movies.results.length > 0 ? (
          movies.results.map((movie) => (
            <div key={movie.id} className="col-6 col-md-4 col-lg-3">
              <MovieCard movie={movie} />
            </div>
          ))
        ) : (
          <p className="text-center">😢 No movies found</p>
        )}
      </div>

      {/* Pagination */}
      <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
        <button
          className="btn btn-outline-primary"
          disabled={page === 1}
          onClick={() => goToPage(page - 1)}
        >
          <FaChevronLeft />
        </button>



        {[...Array(totalPages)].map((_, idx) => (
          <button
            key={idx + 1}
            className={`btn ${page === idx + 1 ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => goToPage(idx + 1)}
          >
            {idx + 1}
          </button>
        ))}

        <button
          className="btn btn-outline-primary"
          disabled={page === totalPages}
          onClick={() => goToPage(page + 1)}
        >
          <FaChevronRight />
        </button>

      </div>

      <ToastContainer />
    </div>
  );
};

export default Movies;
